import {CalendarIcon, colors, Decoration} from '@bettermarks/bm-ui-components';
import {Button, ButtonProps} from '@chakra-ui/react';
import {ReactElement} from 'react';
import {CaretIcon, Orientation} from '../../components/Icons';
import {Knob, KnobType, KnobVariant} from '../../components/Knob';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps
} from 'react-router-dom';
import {
  BsArrowRight,
  BsFillCalendarPlusFill,
  BsFillCalendarCheckFill,
  BsArrowRightShort,
  BsCalendar
} from 'react-icons/bs';
import {props} from 'lodash/fp';
import React from 'react';

interface CustomButtonProps extends ButtonProps {
  onClick: any;
}

type RouterButtonProps = RouterLinkProps & ButtonProps;

// const RouterButton: React.FC<RouterButtonProps> = ({children}) => {
//   return <Button {...props}>{children}</Button>;
// };

const RouterButton: React.FC<RouterButtonProps> = React.forwardRef(
  (props: RouterButtonProps, ref: React.Ref<any>) => {
    return <Button ref={ref} as={RouterLink} {...props} />;
  }
);

export const ActionButtonKnob =
  (goToPlanning: any, addToPlan: any, stopProp: (e: Event) => boolean) =>
  (
    id: string,
    isPlanned: boolean,
    libraryId: string,
    color: string
  ): ReactElement =>
    (isPlanned && (
      <>
        <RouterButton
          rightIcon={<BsArrowRightShort size={22} />}
          to='/planning'
          variant='solid'
          colorScheme='blue'
          size='sm'
        >
          In der Planung ansehen
        </RouterButton>
      </>
    )) || (
      <>
        <Button
          leftIcon={<BsFillCalendarPlusFill size={18} />}
          onClick={() => addToPlan(id, libraryId, color)}
          variant='solid'
          colorScheme='blue'
          size='sm'
        >
          Zur Planung hinzufügen
        </Button>
      </>
    );

export const bookImage = (bookIcon?: string): string =>
  (bookIcon && !bookIcon.endsWith('.png') && `/topic-icons/${bookIcon}`) ||
  '/topic-icons/capital-X.svg';
export const dialogue = (isPlanned: boolean) =>
  (isPlanned && 'Dieses Modul wurde bereits zur Planung hinzugefügt.') ||
  'Möchten Sie dieses Modul zur Planung hinzufügen?';
